const covertToISO_3166_1_alpha_2_code = (code) => {
    switch (code.toLowerCase()) {
        case 'pl-pl':
            return "pl"
        case 'en-gb':
        case 'en-us':
            return 'gb'
        case 'ru-ru':
            return 'ru'
        default:
            return null;
    }
}

export const languageHelper = {
    covertToISO_3166_1_alpha_2_code
}